import { render, staticRenderFns } from "./CreateTermsAndConditions.vue?vue&type=template&id=e18ca57c"
import script from "./CreateTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./CreateTermsAndConditions.vue?vue&type=script&lang=js"
import style0 from "./CreateTermsAndConditions.vue?vue&type=style&index=0&id=e18ca57c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports